const SNAPSHOT_STORAGE_KEY = 'registration_site_info_snapshot'

let currentSnapshot = null

function selectCurrency(currency) {
  if (!currency || typeof currency !== 'object') {
    return null
  }

  return {
    code: currency.code ?? null,
    name: currency.name ?? null,
    objId: currency.objId ?? null,
  }
}

function createSnapshot(data) {
  if (!data || typeof data !== 'object') {
    return null
  }

  const siteInfo = data.siteInfo
  if (!siteInfo || typeof siteInfo !== 'object') {
    return null
  }

  return {
    siteInfo: {
      region: siteInfo.region ?? null,
      realRegion: siteInfo.realRegion ?? null,
      availableRegions: Array.isArray(siteInfo.availableRegions) ? [...siteInfo.availableRegions] : [],
      isWebview: siteInfo.isWebview ?? false,
      mirrorDomain: siteInfo.mirrorDomain ?? null,
    },
    currencies: Array.isArray(data.currencies) ? data.currencies.map(selectCurrency).filter(Boolean) : [],
    defaultCurrency: selectCurrency(data.defaultCurrency),
  }
}

export function readRegistrationSiteInfo() {
  try {
    const value = sessionStorage.getItem(SNAPSHOT_STORAGE_KEY)
    return value ? JSON.parse(value) : currentSnapshot
  } catch {
    return currentSnapshot
  }
}

function removePersistedSnapshot() {
  try {
    sessionStorage.removeItem(SNAPSHOT_STORAGE_KEY)
  } catch {
    // Registration must not depend on browser storage availability.
  }
}

export function rememberRegistrationSiteInfo(data) {
  currentSnapshot = createSnapshot(data)
}

export function persistRegistrationSiteInfo() {
  if (!currentSnapshot) {
    return
  }

  try {
    sessionStorage.setItem(SNAPSHOT_STORAGE_KEY, JSON.stringify(currentSnapshot))
  } catch {
    // Social auth can continue without the diagnostic snapshot.
  }
}

export function clearPersistedRegistrationSiteInfo() {
  removePersistedSnapshot()
}

export function clearRegistrationSiteInfo() {
  currentSnapshot = null
  removePersistedSnapshot()
}
